import { render, staticRenderFns } from "./rh_pessoas.vue?vue&type=template&id=6215b6de&scoped=true&"
import script from "./rh_pessoas.vue?vue&type=script&lang=js&"
export * from "./rh_pessoas.vue?vue&type=script&lang=js&"
import style0 from "./rh_pessoas.vue?vue&type=style&index=0&id=6215b6de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6215b6de",
  null
  
)

export default component.exports